import script from "./ReportDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportDetailPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import DynamicReport from "@/components/reports/DynamicReport.vue";
import ReportDownloadHistory from "@/components/reports/ReportDownloadHistory.vue";
import SecondaryNav from "@/components/SecondaryNav.vue";
import SecondaryTop from "@/components/SecondaryTop.vue";
script.components = Object.assign({}, { DynamicReport, ReportDownloadHistory, SecondaryNav, SecondaryTop }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { DynamicReport, ReportDownloadHistory, SecondaryNav, SecondaryTop }, script.__o.components);}